import { API, graphqlOperation } from "aws-amplify";
import { getJsonTemplate } from "../../../queries";
const getSoeTemplateJson = async (classId: number, activityId: number, valueId: number, title: string, template: string) => {
  try {
    // Make API call to get progress
    const response: any = await API.graphql(graphqlOperation(getJsonTemplate(classId, activityId, valueId, title, template)));
    if (response.data) {
      return response.data.getProductivityToolDetails;
    }
  } catch (error: any) {
    console.log(error);
  }
};


const removeBoldTags = (inputString: string) => {
  return inputString.replace(/<\/?b>/g, "");
}
export { getSoeTemplateJson, removeBoldTags };
